import {CoreDI, inject, injectable, IService, System, SystemComponentType} from '@gongxigames/framework/core';

@injectable()
export class PixiJSDevtoolsService implements IService {
    public static NAME = 'PixiJSDevtoolsService';
    public type: SystemComponentType = 'service';

    @inject(CoreDI.System)
    private readonly system!: System;

    public init(): void {
        window.__PIXI_APP__ = this.system.app;
        (window as any).__PIXI_RENDERER__ = this.system.renderer;
    }
}
